var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[_c('header',[_c('NavBar',{staticClass:"fixed-top"})],1),_vm._v(" "),_c('main',{staticClass:"vw-100 min-vh-100",style:(_vm.mainStyle)},[_vm._t("default"),_vm._v(" "),_vm._t("bottom-main")],2),_vm._v(" "),_c('FooterContainer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }